import { render, staticRenderFns } from "./AuthorizationCode.vue?vue&type=template&id=0973d06e&scoped=true&"
import script from "./AuthorizationCode.vue?vue&type=script&lang=js&"
export * from "./AuthorizationCode.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationCode.vue?vue&type=style&index=0&id=0973d06e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0973d06e",
  null
  
)

export default component.exports